var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,17.7989899 6.20101013,22.5 12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,6.20101013 17.7989899,1.5 12,1.5 Z M12,5.25 C12.3796958,5.25 12.693491,5.53215388 12.7431534,5.89822944 L12.75,6 L12.75,11.25 L18,11.25 C18.4142136,11.25 18.75,11.5857864 18.75,12 C18.75,12.3796958 18.4678461,12.693491 18.1017706,12.7431534 L18,12.75 L12.75,12.75 L12.75,18 C12.75,18.4142136 12.4142136,18.75 12,18.75 C11.6203042,18.75 11.306509,18.4678461 11.2568466,18.1017706 L11.25,18 L11.25,12.75 L6,12.75 C5.58578644,12.75 5.25,12.4142136 5.25,12 C5.25,11.6203042 5.53215388,11.306509 5.89822944,11.2568466 L6,11.25 L11.25,11.25 L11.25,6 C11.25,5.58578644 11.5857864,5.25 12,5.25 Z",
    id: "Shape",
    fill: "#3B7FF5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportReports);
export default __webpack_public_path__ + "static/media/import-reports.576a9c8c09e7ff59617a0d1526b1f332.svg";
export { ForwardRef as ReactComponent };